import { Asset, Event, EventDescription } from './schema'

export const eventTypesObj = {
  ALL: 'Alle',
  EVENTS: 'Events',
  TRAINING: 'Training',
  OPLEIDING: 'Opleiding',
  COACHING: 'Coaching',
  ADVIES: 'Advies',
  INSPIRATIESESSIES: 'Inspiratiesessies',
}

export const pinnedEventObj: EvnetTypeValues = {
  ALL: 'pinnedEventAll',
  EVENTS: 'pinnedEventEvent',
  TRAINING: 'pinnedEventTraining',
  OPLEIDING: 'pinnedEventOpleiding',
  COACHING: 'pinnedEventCoaching',
  ADVIES: 'pinnedEventAdvies',
  INSPIRATIESESSIES: 'pinnedEventInspiratiesessies',
}

export type EventTypeNames =
  | 'ALL'
  | 'EVENTS'
  | 'TRAINING'
  | 'OPLEIDING'
  | 'COACHING'
  | 'ADVIES'
  | 'INSPIRATIESESSIES'

export const locationOptions = [
  { value: 'Rvdb kantoor', label: 'Rvdb kantoor' },
  { value: 'Incompany', label: 'Incompany' },
  { value: 'Extern', label: 'Extern' },
  { value: 'Online', label: 'Online' },
]

export type EvnetTypeValues = Record<EventTypeNames, string>

export type EventsTabsContentKeys = keyof typeof eventTypesObj

export type EventsTabsContentValues =
  (typeof eventTypesObj)[EventsTabsContentKeys]

export enum CardWithImgPosition {
  TOP = 'top',
  LEFT = 'left',
}

export type EventCardWithImageProps = Pick<Event, 'title' | 'description'> & {
  publicationDate?: Date | null
  className?: string
  image: Omit<Asset, 'sys' | 'contentfulMetadata' | '_id'> | undefined
  buttonText?: string
  buttonLink?: string
  description: EventDescription | undefined
  imgPosition: CardWithImgPosition
}
